import { render, staticRenderFns } from "./ShiftsSubMenuCalendar.vue?vue&type=template&id=ac0a2610&scoped=true&"
import script from "./ShiftsSubMenuCalendar.vue?vue&type=script&lang=js&"
export * from "./ShiftsSubMenuCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsSubMenuCalendar.vue?vue&type=style&index=0&id=ac0a2610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0a2610",
  null
  
)

export default component.exports